import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, watch } from 'vue';

type PopoverTrigger = 'click' | 'hover';

type Props = {
  trigger?: PopoverTrigger;
  align?: string;
  detached?: boolean;
  position?: 'above' | 'below';
  style?: any;
};


export default /*#__PURE__*/_defineComponent({
  props: {
    trigger: { default: 'click' },
    align: { default: 'right' },
    detached: { type: Boolean, default: false },
    position: { default: undefined },
    style: { default: undefined }
  },
  emits: ["show", "hide"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'show'): void;
  (e: 'hide'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { trigger: PopoverTrigger, align: string, detached: boolean, position: 'above' | 'below', style: any }

_useCssVars(_ctx => ({
  "7beeba2e": (_unref(activatorHalfWidthPx)),
  "6104a361": (_unref(activatorWidthPx))
}))





/**
 * STATE
 */
const popoverOpened = ref(false);
const activatorWrapper = ref<HTMLDivElement>();

/**
 * COMPUTED
 */
const popoverWrapperClasses = computed(() => ({
  'bal-popover-wrapper-visible': popoverOpened.value,
  [`${props.align}-0`]: !props.detached,
  'align-center-transform': props.detached && props.align === 'center',
  'align-right-transform': props.detached && props.align === 'right',
  'bal-popover-above': props.position === 'above',
  'bal-popover-below': props.position === 'below',
}));

const popoverActivatorWrapperClasses = computed(() => ({
  relative: !props.detached,
}));

const activatorWidth = computed(() => activatorWrapper.value?.clientWidth || 0);

const activatorWidthPx = computed(() => `${activatorWidth.value}px`);

const activatorHalfWidthPx = computed(() => `${activatorWidth.value / 2}px`);

/**
 * METHODS
 */
function togglePopover() {
  popoverOpened.value = !popoverOpened.value;
}

function showPopover() {
  popoverOpened.value = true;
}

function hidePopover() {
  popoverOpened.value = false;
}

function handleClickOutside() {
  if (props.trigger === 'click') {
    hidePopover();
  }
}

/**
 * WATCHERS
 */
watch(popoverOpened, () => {
  if (popoverOpened.value) {
    emit('show');
  } else {
    emit('hide');
  }
});

return (_ctx: any,_cache: any) => {
  const _component_BalCard = _resolveComponent("BalCard")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_unref(popoverActivatorWrapperClasses)])
  }, [
    _createElementVNode("div", {
      ref: (_value, _refs) => {
        _refs['activatorWrapper'] = _value
        activatorWrapper.value = _value
      },
      class: "group bal-popover-activator",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.trigger === 'click' && togglePopover())),
      onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (__props.trigger === 'hover' && showPopover())),
      onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (__props.trigger === 'hover' && hidePopover()))
    }, [
      _renderSlot(_ctx.$slots, "activator")
    ], 544),
    _createElementVNode("div", {
      class: _normalizeClass(['bal-popover-wrapper', _unref(popoverWrapperClasses)]),
      style: _normalizeStyle(props.style)
    }, [
      _createVNode(_component_BalCard, _mergeProps({ shadow: "lg" }, _ctx.$attrs, { darkBgColor: "800" }), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", { close: hidePopover })
        ]),
        _: 3
      }, 16)
    ], 6)
  ], 2)), [
    [_directive_click_outside, handleClickOutside]
  ])
}
}

})